export enum eNewaddActive {
  NEW_USER = 'new_user',
  ACTIVE_USER = 'active_user',
  CHARGE_USER = 'charge_user',
  CONSUME_USER = 'consume_user',
}
